<div class="floating-feedback-panel" (click)="$event.stopPropagation()">
  <img class="close-button" src="assets/images/common/cancel.svg" (click)="onClose($event)" alt="close" />
  @if (!feedbackSubmitted()) {
    @if (!feedbackChoice()) {
      <!-- Initial question -->
      <div class="feedback-question">
        <div class="feedback-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2v10Z"
              stroke="white"
              stroke-width="2"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
        </div>
        <span class="feedback-text">Is this risk accurate?</span>
        <div class="feedback-buttons">
          <button type="button" class="feedback-btn feedback-btn-yes" (click)="onFeedbackClick(true, $event)">
            Yes
          </button>
          <button type="button" class="feedback-btn feedback-btn-no" (click)="onFeedbackClick(false, $event)">
            No
          </button>
        </div>
      </div>
    } @else {
      <!-- Comment input section -->
      <div class="feedback-form-section">
        @if (feedbackChoice() === 'helpful') {
          <h3 class="feedback-form-title">
            That's helpful. Anything missing from this issue, or that would make it even better?
          </h3>
        } @else {
          <h3 class="feedback-form-title">What's off? Share any details that would help us improve accuracy.</h3>
        }
        <textarea
          class="feedback-comment-textarea"
          placeholder="Your feedback will help us improve this feature"
          [value]="feedbackComment()"
          (input)="onFeedbackCommentChange($any($event.target).value)"
          (click)="$event.stopPropagation()"
          [disabled]="isSubmittingFeedback()"
          rows="5"
        ></textarea>
        <button
          type="button"
          class="feedback-send-btn"
          (click)="onSubmitFeedback($event)"
          [disabled]="isSubmittingFeedback()"
        >
          @if (isSubmittingFeedback()) {
            <mat-progress-spinner class="button-spinner" color="primary" mode="indeterminate" diameter="14">
            </mat-progress-spinner>
          } @else {
            Send
          }
        </button>
      </div>
    }
    @if (feedbackError()) {
      <div class="feedback-error">
        {{ feedbackError() }}
      </div>
    }
  } @else {
    <!-- Thank you message -->
    <div class="feedback-thank-you-section">
      <h3 class="feedback-thank-you-title">Thank you for your feedback!</h3>
      <p class="feedback-thank-you-subtitle">Our team will review it shortly.</p>
    </div>
  }
</div>
